import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import ReactiveRepairs_Section1 from "./sections/ReactiveRepairs_Section1";

function ReactiveRepairs() {
  usePageMeta({
    title: "Reactive Repairs & Emergency Response Ireland | Spechs",
    description:
      "Fast reactive repairs and emergency property response across Ireland. Available when you need us most.",
    canonical: "https://www.spechs.ie/property/reactive-repairs/",
  });
  return (
    <SubPageLayout title="Reactive Repairs & Emergency Response">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <ReactiveRepairs_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default ReactiveRepairs;
